import { CPError, CPErrorResponse, CPException } from "@EspaceParkQC/sdk-services-legacy";
import { AxiosError, AxiosResponse } from "axios";

export const extractDataFromResponse = <T>(response: AxiosResponse<T>): T => {
  if (!response?.data) {
    throw new Error("Response data is undefined");
  }

  return response.data;
};

export const convertErrorToCPException = (error: unknown): never => {
  const exception: AxiosError = error as AxiosError<CPErrorResponse>;
  const errorData = exception.response?.data as CPErrorResponse | undefined;
  if (!errorData?.error) throw error;
  throw new CPException(errorData.error);
};

export const convertCentralServerErrorToCPException = (error: unknown): CPException | Error => {
  const axiosError = error as AxiosError;
  const errorData = axiosError.response?.data;

  /* Central server is supposed to use a middleware to convert old ClicknparkError to new CPException format so this code should be reached. */
  if (errorData && typeof errorData === "object" && "error" in errorData) {
    if (errorData.error && typeof errorData.error === "object") {
      const error = errorData.error;
      if ("code" in error && "message" in error && "ref" in error) {
        return new CPException({
          type: "CPError",
          status: axiosError.response?.status ?? 500,
          code: error.code as CPError["code"],
          ref: error.ref as string,
          clientContext: { message: error.message as string },
        });
      }
    }
  }

  /* Central server is supposed to use a middleware to convert old ClicknparkError to new CPException format
  so this code should never be reached, but it's here as a fallback. */
  if (errorData && typeof errorData === "object" && "type" in errorData) {
    if (errorData.type === "ClicknparkError") {
      if ("code" in errorData && "description" in errorData && "status" in errorData) {
        return new CPException({
          type: "CPError",
          status: errorData.status as number,
          code: errorData.code as number,
          clientContext: { message: errorData.description as string },
        });
      }
    }
  }

  // Fallback if error data doesn't match expected format
  return Error(`Unknown error occurred when communicating with the server: ${JSON.stringify(errorData)}`);
};
